import React from 'react';
import { Flex, Card, Image, Rate, Tag } from 'antd';
import { QrcodeOutlined, ShareAltOutlined, LinkOutlined, ShoppingOutlined, CopyOutlined, MinusCircleOutlined } from '@ant-design/icons';
// import CardContent from './card-content';
import { getCurrentShopId } from '../shop/get-current-shop';
import { openWxminiGoods } from './tools';

export default ({content = {}, onProxyClick, onProxyCancel}) => {
    const accId = window.__baseInfo.accId;
    const {
        goodsId, cateId,
        type, title, status, minNum, realSaleNum, offlineSaleNum, inventory, shortDescription, sysCateId,
        properties, price, marketPrice, prepaidAmount, createTime, uuid, unit, mainImages,
        goods_partner_level_percents, 
        shopId_shops,               // 代理关系数据
        rating = {}
    } = content;
    const [isOpen, setIsOpen] = React.useState(false);

    // 获取代理佣金
    const profit = goods_partner_level_percents && goods_partner_level_percents[0] ? goods_partner_level_percents[0].percent : 0;
    
    // 构造商品展示数据
    const areas = [];
    const fromShops = [];

    shopId_shops?.forEach(item => {
        if(item.fromShop) {
            fromShops.push(item.fromShop);

            const { shop_biz_address } = item.fromShop;

            if(shop_biz_address) {
                if(shop_biz_address.city) areas.push(shop_biz_address.city);
                else if(shop_biz_address.province) areas.push(shop_biz_address.province);
            }
        }

    });

    if(areas.length === 0) {
        areas.push('未知');
    }

    const onWxGoodsUrlClick = async () => {
        const currentShopId = await getCurrentShopId();
        if (!currentShopId) return;
        await openWxminiGoods(accId, currentShopId, goodsId);
    }

    const CardHeader = props => {
        return (
            <Flex justify="space-between">
                <div style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{title}</div>
                <Flex gap={10}>
                    {/* <div><ShareAltOutlined /></div>
                    <div><QrcodeOutlined /></div> */}
                    <a onClick={onWxGoodsUrlClick}><LinkOutlined /></a>
                </Flex>
            </Flex>
        )
    }

    const actions = [
        <div onClick={onWxGoodsUrlClick}><ShoppingOutlined key="edit" /> 商品详情</div>,
        <div onClick={() => onProxyCancel?.(content)}><MinusCircleOutlined key="cancel" /> 取消代理</div>,
    ];

    return (
        <Card title={<CardHeader />} style={{minWidth: 360, maxWidth: 456, width: '100%'}}
            actions={actions}
        >
            <Flex justify="" align="left" gap={10} style={{fontSize: 12}}>
                <Image
                    width={80}
                    height={80}
                    src={`//img.yxdj.tech/${mainImages[0]}?x-oss-process=image/resize,w_200`}
                />
                <div>
                    <span>价格：{price/100}元/{unit} <del>{marketPrice/100}元</del> 销量：{realSaleNum}</span>
                    <div>服务评分：{rating.score ? <Rate allowHalf defaultValue={rating.score} /> : '暂无评分'} </div>
                    <div>代理佣金：{profit}%</div>
                    <div>服务区域：{ areas.map((c, i) => (<Tag key={i}>{c}</Tag>))}</div>
                    <div>服务来自：{ fromShops.map((c, i) => (<a style={{marginRight: 10}} href={`?shopId=${c.shopId}`} key={i}>{c.title}</a>))}</div>
                </div>
            </Flex>
        </Card>
    )
}